const apiGet = async (url, params = {}) => {
  const query = new URLSearchParams(params).toString();
  const fullUrl = query ? `${url}?${query}` : url;

  try {
    const response = await fetch(fullUrl, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
    });

    const data = await response.json();
    return data;
  } catch (error) {
    console.error("GET request failed:", error);
    throw error;
  }
};

const apiPost = async (url, body = {}) => {
  console.log("body", body, url);
  try {
    const response = await fetch(url, {
      method: "POST",
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
      },
      body: JSON.stringify(body),
    });

    const data = await response.json();
    return data;
  } catch (error) {
    console.error("POST request failed:", error);
    throw error;
  }
};

const uploadDoc = async (url, formData) => {
  try {
    const response = await fetch(url, {
      method: "POST",
      body: formData, // ✅ browser sets the correct Content-Type + boundary
    });

    const data = await response.json();
    return data;
  } catch (error) {
    console.error("POST request failed:", error);
    throw error;
  }
};

const downloadDoc = async (url, body = {}, docName) => {
  console.log("body", docName);
  try {
    const response = await fetch(url, {
      method: "POST",
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
      },
      body: JSON.stringify(body),
    });

    const blob = await response.blob();
    const url1 = window.URL.createObjectURL(blob);

    const a = document.createElement("a");
    a.href = url1;
    a.download = docName;
    document.body.appendChild(a);
    a.click();
    a.remove();

    window.URL.revokeObjectURL(url1);
    // return data;
  } catch (error) {
    console.error("POST request failed:", error);
    throw error;
  }
};

export { apiGet, apiPost, uploadDoc, downloadDoc };
